import { bindActionCreators } from 'redux';

// Actions
export const UPDATE_VISIBILITY = 'moblee/site-server/UPDATE_VISIBILITY';

const initialState = { visible: true };

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_VISIBILITY: {
      return {
        visible: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

// Action creators
export function updateVisibility(payload) {
  return {
    type: UPDATE_VISIBILITY,
    payload,
  };
}

export function mapStateToProps(state) {
  return state.couponSnackbar;
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateVisibility }, dispatch);
}



// WEBPACK FOOTER //
// ./src/site-render/src/redux/couponSnackbar.js